module.exports = __webpack_public_path__ + "h5/img/logo2.216fd948.png";